var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalledebainmaiden({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 598.2 599.3",
    style: {
      enableBackground: "new 0 0 598.2 599.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-width:8;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.1,252.8H272v-7.5h-88.2v7.5h-43.4c-9.8,0-17.7,8-17.7,17.7c0,8.3,5.8,15.3,13.5,17.2v34.1 c0,25.1,15,46.8,36.5,56.5c-6.2,7.1-9.9,16.3-9.9,26.4h16.8c0-9.3,5.4-17.3,13.2-21.1c1.8,0.2,3.6,0.3,5.5,0.3l208.1,0 c2.9,0,5.7-0.3,8.5-0.7c8.2,3.7,13.9,11.9,13.9,21.5h16.8c0-10.7-4.3-20.4-11.1-27.6c20.2-10.3,34-31.2,34-55.3v-33.6 c9.1-0.7,16.3-8.3,16.3-17.6C484.8,260.7,476.8,252.8,467.1,252.8L467.1,252.8z M195,256.5h65.8v82.6H195V256.5z M133.9,270.5 c0-3.6,2.9-6.5,6.5-6.5h43.4v13.1h-43.4C136.8,277.1,133.9,274.1,133.9,270.5L133.9,270.5z M457.3,321.8 c0,28.1-22.8,50.9-50.9,50.9H198.3c-28.1,0-50.9-22.8-50.9-50.9v-33.5h36.4v62H272v-62h185.3L457.3,321.8z M467,277.1H272V264 h195.1c3.6,0,6.5,2.9,6.5,6.5C473.6,274.1,470.7,277.1,467,277.1L467,277.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalledebainmaiden);
export default __webpack_public_path__ + "static/media/salle de bain maiden.b48a4a9d1f9082858d3005244d13ef19.svg";
export { ForwardRef as ReactComponent };